import { ReactElement } from 'react';
import styled from "styled-components";
import { useTranslation } from 'react-i18next';
import { IonCheckbox } from '@ionic/react';
import { ConsentCheckboxItemType } from '../../../../types/welcome';

interface ConsentCheckboxListProps {
  items: ConsentCheckboxItemType[];
  // itemId -> checked; state lives in the parent (DisplayConsent).
  values: Record<number, boolean>;
  onItemChange: (itemId: number, checked: boolean) => void;
}

// One card row per researcher-authored consent checkbox item. Replaces the single
// generic ConsentCheckbox/ConsentChoice when the CONSENT content carries items.
const ConsentCheckboxList = ({ items, values, onItemChange }: ConsentCheckboxListProps): ReactElement => {
    const { t } = useTranslation();

    // The API already returns items ordered, but sort defensively.
    const orderedItems = [...items].sort((a, b) => a.order - b.order);

  return (
    <div>
      {orderedItems.map((item) => (
        <CheckBox key={item.id}>
          <CheckBoxLabel>
            {item.is_required ? `${item.label} *` : item.label}
            <Mention>
              {item.is_required
                ? t("home_consent_item_required")
                : t("home_consent_item_optional")}
            </Mention>
          </CheckBoxLabel>
          <IonCheckbox
            checked={!!values[item.id]}
            onIonChange={(e) => onItemChange(item.id, e.detail.checked)}
          />
        </CheckBox>
      ))}
    </div>
  );
};

const CheckBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 20px;
  border-radius : 15px;
  background-color : ${props => props.theme.secondary.main};
`;


const CheckBoxLabel = styled.div`
margin-right: max(5px, auto);
flex: 1;
font-weight: bold;
`;

const Mention = styled.div`
  font-size: 0.75rem;
  font-weight: normal;
  font-style: italic;
  opacity: 0.7;
`;

export default ConsentCheckboxList;
